module.exports = __webpack_public_path__ + "static/media/bg-bottom-fact.45cded89.png";